import React from "react";

function TownhouseIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0803 11.7692C10.0803 11.5969 9.93988 11.4562 9.76758 11.4562H9.08423C8.91211 11.4562 8.77148 11.5969 8.77148 11.7692V12.2976H10.0803V11.7692Z"
        fill="#1D891A"
      />
      <path
        d="M8.77148 14.0554H10.0803V17.0126H8.77148V14.0554Z"
        fill="#1D891A"
      />
      <path
        d="M22.9792 11.7692C22.9792 11.5961 22.8391 11.4562 22.6663 11.4562H21.9838C21.811 11.4562 21.6709 11.5961 21.6709 11.7692V12.2976H22.9792V11.7692Z"
        fill="#1D891A"
      />
      <path
        d="M21.6709 14.0554H22.9792V17.0118H21.6709V14.0554Z"
        fill="#1D891A"
      />
      <path
        d="M2.37986 10.5166L10.3047 4.75551L15.2209 8.32973C15.6634 8.65163 16.2627 8.65163 16.7055 8.32973L21.6221 4.75551L29.5879 10.5462C29.7437 10.6599 29.9248 10.7145 30.1042 10.7145C30.3754 10.7145 30.6437 10.5891 30.8154 10.3523C31.1007 9.95992 31.0139 9.41023 30.6215 9.12495L22.5081 3.22658C21.9776 2.84114 21.2659 2.84114 20.7356 3.22658L15.9632 6.69606L11.1907 3.22658C10.661 2.84114 9.94835 2.84114 9.41825 3.22658L1.34642 9.09493C0.953838 9.38039 0.867046 9.92989 1.15251 10.3225C1.4376 10.7149 1.98747 10.8024 2.37986 10.5166Z"
        fill="#1D891A"
      />
      <path
        d="M30.1055 27.0753H28.1594V11.2658L21.6222 6.51312L16.8422 9.98846V27.0753H15.0844V9.98773L10.3054 6.51312L3.76758 11.2658V27.0757H1.86328C1.37805 27.0757 0.984375 27.4694 0.984375 27.9546C0.984375 28.4402 1.37805 28.8335 1.86328 28.8335H30.1055C30.5907 28.8335 30.9844 28.4402 30.9844 27.9546C30.9844 27.4694 30.5907 27.0753 30.1055 27.0753ZM11.8381 27.0753H10.0803V22.0013C10.0803 21.8279 9.93915 21.6862 9.7652 21.6862H9.08679C8.91266 21.6862 8.77148 21.8279 8.77148 22.0013V27.0753H7.01367V22.0013C7.01367 20.858 7.94348 19.9283 9.08679 19.9283H9.7652C10.9085 19.9283 11.8381 20.858 11.8381 22.0013V27.0753ZM11.8381 17.8294C11.8381 18.3481 11.4163 18.7704 10.8973 18.7704H7.95483C7.43555 18.7704 7.01367 18.3481 7.01367 17.8294V11.7692C7.01367 10.627 7.94312 9.69843 9.08423 9.69843H9.76758C10.9089 9.69843 11.8381 10.627 11.8381 11.7692V17.8294ZM24.737 27.0753H22.9792V22.0013C22.9792 21.8273 22.838 21.6862 22.6648 21.6862H21.9857C21.8123 21.6862 21.6709 21.8273 21.6709 22.0013V27.0753H19.9131V22.0013C19.9131 20.858 20.8431 19.9283 21.9857 19.9283H22.6648C23.8074 19.9283 24.737 20.858 24.737 22.0013V27.0753ZM24.737 17.8294C24.737 18.3481 24.3153 18.77 23.7966 18.77H20.8535C20.335 18.77 19.9131 18.3481 19.9131 17.8294V11.7692C19.9131 10.627 20.8418 9.69843 21.9838 9.69843H22.6663C23.8085 9.69843 24.737 10.627 24.737 11.7692V17.8294Z"
        fill="#1D891A"
      />
    </svg>
  );
}

export default TownhouseIcon;
